import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconChevronBottom, IconChevronTop, SpacerHorizontal, TouchableFrame, Typography, View, } from '@klarna/bubble-ui';
const componentPropTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    icon: PropTypes.node,
    titleLarge: PropTypes.bool,
};
const ExpandableFrame = ({ title = '', children, icon = null, titleLarge = false, }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    return (React.createElement(TouchableFrame, { onPress: () => setIsExpanded(!isExpanded), cornerRadiusToken: "corner-radius/s" },
        React.createElement(View, { style: { display: 'flex', flexDirection: 'column' } },
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                } },
                icon && (React.createElement(View, { style: { alignItems: 'left', flexDirection: 'column', paddingRight: '15px' } }, icon)),
                React.createElement(View, { style: { alignItems: 'left', flexDirection: 'column', flexGrow: 1 } },
                    React.createElement(Typography, { textToken: titleLarge
                            ? 'text-style/headings/titles/bold/tertiary'
                            : 'text-style/text/labels/tall/medium' }, title)),
                React.createElement(View, { style: { display: 'flex', flexDirection: 'row', alignItems: 'center' } },
                    React.createElement(SpacerHorizontal, { spaceToken: "space.200" }),
                    isExpanded ? React.createElement(IconChevronTop, null) : React.createElement(IconChevronBottom, null))),
            isExpanded && (React.createElement(View, { style: { paddingLeft: icon ? '35px' : '10px', alignItems: 'left', textAlign: 'left' } },
                React.createElement(SpacerHorizontal, { spaceToken: "space.200" }),
                children)))));
};
ExpandableFrame.displayName = 'ExpandableFrame';
ExpandableFrame.propTypes = componentPropTypes;
export default ExpandableFrame;
